
import { useEffect } from 'react';
import './assets/css/custom.css'

import { HomeRouter } from './routes/router'
import { pdfjs } from 'react-pdf'

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

function App() {

  useEffect(() => {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
    }

    if (localStorage.getItem("tr")) {
      localStorage.removeItem("tr");
    }
  }, []);

 

  // Directly load app without auth
  return <HomeRouter />
}

export default App